export default __webpack_public_path__ + "static/media/img_gas_phase_03.1e0dedb6.png";